module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.caption) { 
__p+='\n    <div class="fmcy-search-filter-caption">\n        '+
((__t=( options.caption ))==null?'':__t)+
'\n    </div>\n';
 } 
__p+='\n<div class="fmcy-search-filter-tabs-region"></div>\n<div class="fmcy-search-filter-dropdown-list-region"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/subfilters/search-filters/search-filters.html
 ** module id = 650
 ** module chunks = 1 7 43 71
 **/